export default {
  "root": "w1i1q",
  "text": "AFPx2",
  "input": "CLAVT",
  "small": "Y5z4e",
  "medium": "IdaHO",
  "large": "l7DMi",
  "webview": "zvOT-",
  "endAdornment": "CuX47",
  "shown": "aqzGN",
  "value": "m8RZZ",
  "spinner": "_94jwp",
  "spin": "_9aglL"
};